import { ChangeDetectionStrategy, Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { AsyncPipe, LowerCasePipe, NgForOf, NgIf, NgOptimizedImage, NgSwitch, NgSwitchCase } from '@angular/common';
import { ComboItem, FloorPipeModule, FoodOptionItem, FoodOptionSelectType } from '@us/web/shared/data-access';
import { TranslocoModule } from '@ngneat/transloco';
import { ProductStore } from '@us/web/categories/data-access';
import { combineLatest, filter, map, takeUntil, tap } from 'rxjs';
import {
    TuiCheckboxBlockModule,
    TuiCheckboxLabeledModule,
    TuiCheckboxModule,
    TuiRadioLabeledModule,
    TuiRadioListModule,
    TuiTextAreaModule
} from '@taiga-ui/kit';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormatCurrencyPipe, selectShop } from '@us/web/shop/data-access';
import { NumberGroupComponent } from '@us/web/shared/ui';
import { TuiButtonModule, TuiRootModule, TuiWrapperModule } from '@taiga-ui/core';
import { TuiDestroyService, TuiIdentityMatcher, tuiIsPresent, TuiLetModule } from '@taiga-ui/cdk';
import { ProductPhotoComponent } from '../../components/product-photo/product-photo.component';
import { ActivatedRoute } from '@angular/router';
import { RouterUtil, RouteUtil } from '@us/web/shared/utils';
import { OpenTimeToDayV2Pipe, selectSelectedShop } from '@us/web/shops/data-access';
import { Store } from '@ngrx/store';
import { LetDirective } from '@ngrx/component';
import { BreadcrumbsComponent } from '@us/web/shared/ui';
import { IonicModule } from '@ionic/angular';
// TODO: fix Circular dependency
// eslint-disable-next-line @nx/enforce-module-boundaries
import { RouteService } from '@us/web/shops/feature';

@Component({
    selector: 'us-product-detail',
    standalone: true,
    imports: [
        NgOptimizedImage,
        TuiRadioLabeledModule,
        FormsModule,
        TuiTextAreaModule,
        TranslocoModule,
        FloorPipeModule,
        FormatCurrencyPipe,
        NumberGroupComponent,
        TuiButtonModule,
        TuiWrapperModule,
        TuiRootModule,
        NgIf,
        LowerCasePipe,
        NgForOf,
        NgSwitch,
        NgSwitchCase,
        TuiCheckboxModule,
        AsyncPipe,
        TuiLetModule,
        ReactiveFormsModule,
        TuiRadioListModule,
        ProductPhotoComponent,
        TuiCheckboxLabeledModule,
        TuiCheckboxBlockModule,
        LetDirective,
        BreadcrumbsComponent,
        IonicModule,
        OpenTimeToDayV2Pipe
    ],
    providers: [ProductStore, TuiDestroyService],
    templateUrl: './product-detail.component.html',
    styleUrls: ['./product-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class ProductDetailComponent implements OnInit {
    private readonly store = inject(Store);
    private readonly route = inject(ActivatedRoute);
    private readonly destroy$ = inject(TuiDestroyService, { self: true });
    protected readonly routeService = inject(RouteService);
    protected readonly productStore = inject(ProductStore);

    readonly shop$ = this.store.select(selectSelectedShop);
    readonly shopCurrent$ = this.store.select(selectShop);
    readonly quantityInStock$ = this.productStore.quantityInStock$;

    readonly homePageUrl$ = this.routeService.homePageUrl$;
    readonly pageYOffset = Number(this.route.snapshot.queryParamMap.get('pageYOffset') || 0);

    readonly disabledAddToCart$ = combineLatest([
        this.productStore.quantity$,
        this.productStore.productAvailable$,
        this.quantityInStock$
    ]).pipe(
        map(
            ([quantity, productAvailable, quantityInStock]) =>
                quantity <= 0 || !productAvailable || quantityInStock == 0
        )
    );

    readonly FoodOptionSelectType = FoodOptionSelectType;
    readonly RouteUtil = RouteUtil;

    readonly optionItemIdentityMatcher: TuiIdentityMatcher<FoodOptionItem> = (t, u) => t.id === u.id;
    readonly comboItemIdentityMatcher: TuiIdentityMatcher<ComboItem> = (t, u) => t.id === u.id;
    found_time = false;

    ngOnInit() {
        this.route.params
            .pipe(
                takeUntil(this.destroy$),
                map(params => Number(params[RouterUtil.Cog.ProductId])),
                filter(tuiIsPresent),
                tap(productId => this.productStore.setProductId(productId))
            )
            .subscribe();

        this.shopCurrent$.subscribe(shop=> {
            if(!shop?.options.turn_on_the_store_chain_link_feature){
                const day = new Date().getDay();
                const time = new Date().toLocaleTimeString('en-GB', { hour: 'numeric', minute: 'numeric' });
                const found = shop?.open_hours
                    .find(e => e.day === day)
                    ?.periods.find(periods => periods.from < time && periods.to > time);
                this.found_time = !found;
            } else {
                this.found_time = false;
            }
        })

    }
}
